import getLightbulbIcon from "./PalstatLightbulbIcon";
import { momentDtoToLocalStringByCulture } from "../../aplUtils/dateHelper";
import { ColumnFilterOrDisplayType, ConfigColumns2 } from "../../types/configColumns2";
import { PalletDetail } from "../../types/palletDetail";
import { Culture } from "../../types/culture";
import { Guid } from "guid-typescript";
import { renderPalletCondition, renderPalletStatus } from "../../aplUtils/statusConditionEnumHelper";
import { DefectType } from "../../types/defectType";
import { renderTopDefectName } from "../../aplUtils/defectsHelper";
import { Site } from "../../types/site";
import { isUsSite } from "../../aplUtils/sitesHelper";

const palstatDefaultColumnData = (
    site: Site,
    culture: Culture,
    showBatchInsteadOfLot: boolean,
    bulk: boolean,
    defectTypes: DefectType[]
): ConfigColumns2[] => {
    let columndata: ConfigColumns2[];

    const lineId = { data: "lineId", visible: false, width: "0px", title: "lineId" };
    const lineSapCode = {
        data: "lineSapCode",
        width: "5%",
        className: "nowrap, td-overflow",
        title: "line",
        dropdown: true
    };
    const batch = {
        data: "batch",
        className: "nowrap, td-overflow",
        width: "4%",
        title: "batch",
        dropdown: true
    };
    const lot = { data: "lot", className: "nowrap, td-overflow", width: "4%", title: "lot" };
    const sequenceNo = { data: "sequenceNo", width: "5%", className: "nowrap, td-overflow", title: "rank" };
    const statusId = {
        data: "statusId",
        render: function (data: PalletDetail, type: ColumnFilterOrDisplayType | undefined) {
            return renderPalletStatus(data.statusId, culture);
        },
        className: "nowrap, td-overflow",
        width: "12%",
        title: "status",
        dropdown: true,
        dropdownSelectAll: true
    };
    const conditionId = {
        data: "conditionId",
        render: function (data: PalletDetail, type: ColumnFilterOrDisplayType | undefined) {
            return renderPalletCondition(data.conditionId, culture);
        },
        className: "nowrap, td-overflow",
        width: "12%",
        title: "condition",
        dropdown: true,
        dropdownSelectAll: true
    };
    const topDefectId = {
        data: "topDefectId",
        className: "nowrap, td-overflow",
        width: "24%",
        title: "defects",
        render: function (data: PalletDetail, type: ColumnFilterOrDisplayType | undefined) {
            return renderTopDefectName(data, defectTypes);
        },
        dropdown: true
    };
    const dtoPalletProductionDate = {
        data: "dtoPalletProductionDate",
        className: "nowrap, td-overflow",
        render: function (data: PalletDetail, type: ColumnFilterOrDisplayType | undefined) {
            return type === "sort" ? data.dtoPalletProductionDate : momentDtoToLocalStringByCulture(data.dtoPalletProductionDate, culture);
        },
        width: "10%",
        title: "prodDate"
    };
    const sscc = { data: "sscc", className: "nowrap", width: "10%", title: "sscc" };
    const workOrder = { data: "workOrder", className: "nowrap, td-overflow", width: "8%", title: "workOrder", dropdown: true };
    const materialSapCode = {
        data: "materialSapCode",
        className: "nowrap, td-overflow",
        width: "8%",
        title: "partCode",
        dropdown: true
    };
    const actualQty = { data: "actualQty", className: "nowrap, td-overflow", width: "4%", title: "actQty", dropdown: true };
    const palletId = { data: "palletId", visible: false, title: "palletId" };
    const blockedQiBefore = {
        data: "blockedQiBefore",
        render: function (data: PalletDetail, type: ColumnFilterOrDisplayType | undefined) {
            if (type === "filter") {
                if (data.blockedQiBefore === 0) return "0n" as string;
                else return "1y" as string;
            }

            if (data.blockedQiBefore === 1 && type === "display") {
                return getLightbulbIcon(Guid.createEmpty());
            }
            return "";
        },
        width: "5%",
        title: "blockQi"
    };
    const wasBlocked = {
        data: "wasBlocked",
        visible: false,
        width: "5%",
        title: "wasBlocked"
    };
    const checkbox = {
        data: "",
        className: "select-checkbox",
        width: "3%",
        title: ""
    };
    const lineDescription = {
        data: "lineDescription",
        width: "5%",
        className: "nowrap, td-overflow",
        title: "line",
        dropdown: true
    };
    const speakingPartNo = {
        data: "speakingPartNo",
        className: "nowrap, td-overflow",
        width: "10%",
        title: "material12"
    };

    if (isUsSite(site)) {
        columndata = [
            lineId,
            palletId,
            sscc,
            sequenceNo,
            lineSapCode,
            batch,
            actualQty,
            workOrder,
            dtoPalletProductionDate,
            materialSapCode,
            statusId,
            conditionId,
            topDefectId,
            blockedQiBefore,
            wasBlocked
        ];
    } else if (site.siteId === 7) {
        columndata = [
            lineId,
            palletId,
            checkbox,
            lineSapCode,
            lot,
            sequenceNo,
            statusId,
            conditionId,
            topDefectId,
            dtoPalletProductionDate,
            sscc,
            workOrder,
            materialSapCode,
            actualQty
        ];
    } else if (site.siteId > 0 && site.siteId <= 4) {
        columndata = [
            lineId,
            palletId,
            sscc,
            sequenceNo,
            lineDescription,
            lot,
            actualQty,
            workOrder,
            dtoPalletProductionDate,
            materialSapCode,
            speakingPartNo,
            statusId,
            conditionId,
            topDefectId,
            blockedQiBefore,
            wasBlocked
        ];
    } else if (showBatchInsteadOfLot) {
        columndata = [
            lineId,
            palletId,
            sscc,
            dtoPalletProductionDate,
            lineSapCode,
            sequenceNo,
            batch,
            actualQty,
            workOrder,
            materialSapCode,
            statusId,
            conditionId,
            topDefectId,
            blockedQiBefore,
            wasBlocked
        ];
    } else {
        columndata = [
            lineId,
            palletId,
            sscc,
            sequenceNo,
            lineSapCode,
            lot,
            actualQty,
            workOrder,
            dtoPalletProductionDate,
            materialSapCode,
            statusId,
            conditionId,
            topDefectId,
            blockedQiBefore,
            wasBlocked
        ];
    }
    let checkBoxesColumn: ConfigColumns2 = {
        data: "",
        className: "select-checkbox pl-2 pr-2",
        width: "2%",

        title: ""
    };
    if (bulk && site.siteId !== 7) {
        columndata.splice(2, 0, checkBoxesColumn);
    }
    return columndata;
};

const palstatDefaultOrderData = (siteId: number, culture: string, showBatchInsteadOfLot: boolean, bulk: boolean) => {
    let bulkShift = bulk && siteId !== 7 ? 1 : 0;
    if (siteId === 7) {
        return [
            [3, "desc"],
            [9, "desc"]
        ];
    } else if (siteId > 0 && siteId <= 4) {
        return [[8 + bulkShift, "desc"]];
    } else if (showBatchInsteadOfLot) {
        return [[8 + bulkShift, "desc"]];
    } else {
        return [[8 + bulkShift, "desc"]];
    }
};

export { palstatDefaultColumnData, palstatDefaultOrderData };
